import { render, staticRenderFns } from "./PanelLink.vue?vue&type=template&id=0670441a&scoped=true&"
import script from "./PanelLink.vue?vue&type=script&lang=js&"
export * from "./PanelLink.vue?vue&type=script&lang=js&"
import style0 from "./PanelLink.vue?vue&type=style&index=0&id=0670441a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670441a",
  null
  
)

export default component.exports